<template>
<div class="wlx-apply-table-wrapper">
    <div class="pc-apply-table-main">
        <div class="basic-head-main" :style="{backgroundImage:'url('+headBg+')'}">
            <div class="basic-head-con">
                <div class="head-title-con clearfix">
                    <div class="fl basic-book-img-con">
                        <img src="~assets/images/basic-book-img.png" alt />
                    </div>
                    <div class="fr head-title-word">
                        <p class="p-title-1" style="font-size:30px;">中国饭店协会人力资源专业委员会会员申请表(院校)</p>
                        <p class="p-title-2 p-title-2-1">——中国饭店协会</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="apply-table-content">
            <el-form :model="form" :rules="rules" ref="form">
                <table border="0" cellspacing="0" cellpadding="0">
                    <tr>
                        <td colspan="2" class="u-label-title">院校名称</td>
                        <td colspan="11">
                            <el-input v-model="form.schoolName"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2" class="u-label-title">专委会代表人</td>
                        <td colspan="2">
                            <el-input v-model="form.representative"></el-input>
                        </td>
                        <td colspan="2" class="u-label-title">职务</td>
                        <td colspan="2">
                            <el-input v-model="form.rePost"></el-input>
                        </td>
                        <td colspan="2" class="u-label-title">联系电话</td>
                        <td colspan="3">
                            <el-input v-model="form.rePhoneNum"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2" class="u-label-title">联络人</td>
                        <td colspan="2">
                            <el-input v-model="form.contactPerson"></el-input>
                        </td>
                        <td colspan="2" class="u-label-title">职务</td>
                        <td colspan="2">
                            <el-input v-model="form.coPost"></el-input>
                        </td>
                        <td colspan="2" class="u-label-title">联系电话</td>
                        <td colspan="3">
                            <el-input v-model="form.coPhoneNum"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2" class="u-label-title">通讯地址</td>
                        <td colspan="2">
                            <el-input v-model="form.linkAddress"></el-input>
                        </td>
                        <td colspan="2" class="u-label-title">邮箱</td>
                        <td colspan="2">
                            <el-input v-model="form.linkPost"></el-input>
                        </td>
                        <td colspan="2" class="u-label-title">联系微信</td>
                        <td colspan="3">
                            <el-input v-model="form.linkWechat"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2" class="u-label-title">院校面积</td>
                        <td colspan="2">
                            <el-input v-model="form.schoolArea"></el-input>
                        </td>
                        <td colspan="2" class="u-label-title">院校人数</td>
                        <td colspan="2">
                            <el-input v-model="form.schoolStuNum"></el-input>
                        </td>
                        <td colspan="2" class="u-label-title">是否“双高”院校</td>
                        <td colspan="3">
                            <el-select v-model="form.isDoubleHeighSchool" placeholder="请选择" style="width:100%;">
                                <el-option label="是" value="是"></el-option>
                                <el-option label="否" value="否"></el-option>
                            </el-select>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2" class="u-label-title">是否“双高”专业</td>
                        <td colspan="2">
                            <el-select v-model="form.isDobleHeighMajor" placeholder="请选择" style="width:100%;">
                                <el-option label="是" value="是"></el-option>
                                <el-option label="否" value="否"></el-option>
                            </el-select>
                        </td>
                        <td colspan="2" class="u-label-title">特色专业</td>
                        <td colspan="2">
                            <el-input v-model="form.characteristicMajor"></el-input>
                        </td>
                        <td colspan="2" class="u-label-title">住宿餐饮相关专业人数</td>
                        <td colspan="3">
                            <el-input v-model="form.majorNum"></el-input>
                        </td>
                    </tr>
                </table>
                <div class="vip-apply-main-con">
                    <div class="vip-apply-item">
                        <p>院校简介（可另附页）：</p>
                        <div class="company-intro-con">
                            <el-input type="textarea" v-model="form.briefIntro"></el-input>
                        </div>
                    </div>
                    <div class="vip-apply-item">
                        <p>单位意见：</p>
                        <div class="unit-idea-con">
                            本单位同意加入中国饭店协会人力资源专业委员会，愿意承担相应责任，积极支
                            持和配合专委会工作。
                        </div>
                        <div class="clearfix person-signName-con">
                            <div class="fl">
                                <div class="clearfix sign-name-1">
                                    <span class="fl sp-sign-label"> 负责人签名：</span>　
                                    <div class="fl">
                                        <el-input v-model="form.signName" size="small"></el-input>
                                    </div>　
                                </div>
                                <div class="clearfix sign-name-2">
                                    <div class="fl">
                                        <el-input v-model="form.year" size="small"></el-input>
                                    </div>
                                    <div class="fl sp-sign-label">年</div>
                                    <div class="fl">
                                        <el-input v-model="form.month" size="small"></el-input>
                                    </div>
                                    <div class="fl sp-sign-label">月</div>
                                    <div class="fl">
                                        <el-input v-model="form.day" size="small"></el-input>
                                    </div>
                                    <div class="fl sp-sign-label">日</div>
                                </div>
                            </div>
                            <div class="fr official-seal-con">（单位公章）</div>
                        </div>
                    </div>
                    <div class="vip-apply-item">
                         <div>附件上传(请上传表格盖章件PDF版本):</div>
                        <applyFileUpload :url="urlAliyunOSS" :files="files" :fileLists="fileList" @done="onAllFilesUpload" class="apply-file-upload"></applyFileUpload>
                    </div>
                    <!-- <div class="vip-apply-item">
                        <div>
                            <span>请填写申请表发送至邮箱：</span>
                            <span>1063668170@qq.com</span>
                        </div>
                        <div>
                            <span>联系人：</span>
                            <span style="margin-right:10px;">孙雷 18651902599</span>
                            <span>张翔 15210791982</span>
                        </div>
                    </div> -->
                    <div class="vip-apply-item">
                        <p class="p-vip-title">备注：</p>
                        <p class="p-vip-title">中国饭店协会人力资源专业委员会是中国饭店协会分支机构，会费标准按照《中国饭店协会会员管理办法》的有关规定执行。</p>
                        <!-- <p class="p-vip-title">1.会员服务费标准</p>
                        <div class="vip-title-indent">
                            按照《中国饭店协会人力资源专业委员会工作规则》，会员服务费分为3类，理
                            事长单位服务费20000元/年，常务副理事单位服务费6000元/年，副理事单位服务费
                            3000元/年，委员单位服务费1000元/年。
                        </div>
                        <p class="p-vip-title">2.会员服务费缴纳账户</p>
                        <div class="vip-title-indent">开户名称：中国饭店协会</div>
                        <div class="vip-title-indent">开 户 行：中国银行北京月坛支行</div>
                        <div class="vip-title-indent">银行账号：3363 5603 2944</div>
                        <div class="vip-title-indent">行　　号：1041 0000 5864</div> -->
                    </div>
                </div>
            </el-form>
            <div class="submit-apply-btn">
                <el-button type="primary" @click="fanhui">返回</el-button>
                <el-button type="primary" @click="submitTable('form',1)" :disabled="isSubmit">提交</el-button>
                <el-button type="primary" :loading="isdownloadloading" @click="printFile">下载申请表</el-button>
            </div>
        </div>
    </div>
    <!-- 是否填写提示弹框 -->
    <el-dialog title="提示" :visible.sync="IsTipsDialog" :close-on-click-modal="false" :width="tipLogWidth">
        <div class="wlx-is-fill-signUp-con" v-if="isShowPc">
            <p>
                <span>
                    您是否已参与报名申请？如已参与，您可以
                    <router-link :to="target" v-if="userInfo.code > 0">直接进入</router-link>
                    <a style="color:blue;cursor:pointer;" @click="Gologin()" v-if="userInfo.code < 0">直接进入</a>
                    后台编辑相关信息
                </span>
            </p>
            <p class="p-name-pass-tip-con">* 用户名为申请人手机号,初始密码为手机号的后6位</p>
        </div>
        <div v-if="!isShowPc">如果已经参加了报名，请使用电脑进行操作。</div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="IsTipsDialog = false">取 消</el-button>
        </span>
    </el-dialog>
    <newLogin :isShow="showObject"></newLogin>
    <!-- 移动端 -->
    <div class="ph-apply-table-main">
        <div class="fill-table-title">
            <i class="wl-icon-xiangzuo" @click="backToPrev"></i> 填写申请信息
        </div>
        <div class="ph-table-content">
            <div class="table-title-con">
                中国饭店协会人力资源专业委员会会员申请表(院校)
            </div>
            <p class="p-table-tip">* 请确保以下信息的真实性，以免造成审核失败</p>
            <ul>
                <li class="tb-form-li clearfix">
                    <span class="sp-label-title">院校名称</span>
                    <el-input v-model="form.schoolName" size="small"></el-input>
                </li>
                <li class="tb-form-li clearfix">
                    <span class="sp-label-title">专委会代表人:</span>
                    <el-input v-model="form.representative" size="small"></el-input>
                </li>
                <li class="tb-form-li clearfix">
                    <span class="sp-label-title">职务:</span>
                    <el-input v-model="form.rePost" size="small"></el-input>
                </li>
                <li class="tb-form-li clearfix">
                    <span class="sp-label-title">联系电话：</span>
                    <el-input v-model="form.rePhoneNum" size="small"></el-input>
                </li>
                <li class="tb-form-li clearfix">
                    <span class="sp-label-title">联络人：</span>
                    <el-input v-model="form.contactPerson" size="small"></el-input>
                </li>
                <li class="tb-form-li clearfix">
                    <span class="sp-label-title">职务：</span>
                    <el-input v-model="form.coPost" size="small"></el-input>
                </li>
                <li class="tb-form-li clearfix">
                    <span class="sp-label-title">联系电话：</span>
                    <el-input v-model="form.coPhoneNum" size="small"></el-input>
                </li>
                <li class="tb-form-li clearfix">
                    <span class="sp-label-title">通讯地址：</span>
                    <el-input v-model="form.linkAddress" size="small"></el-input>
                </li>
                <li class="tb-form-li clearfix">
                    <span class="sp-label-title">邮箱：</span>
                    <el-input v-model="form.linkPost" size="small"></el-input>
                </li>
                <li class="tb-form-li clearfix">
                    <span class="sp-label-title">联系微信：</span>
                    <el-input v-model="form.linkWechat" size="small"></el-input>
                </li>
                <li class="tb-form-li clearfix">
                    <span class="sp-label-title">院校面积：</span>
                    <el-input v-model="form.schoolArea" size="small"></el-input>
                </li>
                <li class="tb-form-li clearfix">
                    <span class="sp-label-title">院校人数：</span>
                    <el-input v-model="form.schoolStuNum" size="small"></el-input>
                </li>
                <li class="tb-form-li clearfix">
                    <span class="sp-label-title" style="vertical-align: -13px;">是否“双高”院校：</span>
                    <el-select v-model="form.isDoubleHeighSchool" placeholder="请选择" size="small" class="select-level-con">
                        <el-option label="是" value="是"></el-option>
                        <el-option label="否" value="否"></el-option>
                    </el-select>
                </li>
                <li class="tb-form-li clearfix">
                    <span class="sp-label-title" style="vertical-align: -13px;">是否“双高”专业：</span>
                    <el-select v-model="form.isDobleHeighMajor" placeholder="请选择" size="small" class="select-level-con">
                        <el-option label="是" value="是"></el-option>
                        <el-option label="否" value="否"></el-option>
                    </el-select>
                </li>
                <li class="tb-form-li clearfix">
                    <span class="sp-label-title">特色专业：</span>
                    <el-input v-model="form.characteristicMajor" size="small"></el-input>
                </li>
                <li class="tb-form-li clearfix">
                    <span class="sp-label-title">住宿餐饮相关专业人数：</span>
                    <el-input v-model="form.majorNum" size="small"></el-input>
                </li>
                <li class="tb-form-li clearfix">
                    <div>院校简介（可另附页）：</div>
                    <div class="ph-intro-con">
                        <el-input type="textarea" v-model="form.briefIntro"></el-input>
                    </div>
                </li>
                <li class="tb-form-li clearfix">
                    <div>单位意见：</div>
                    <div>
                        本单位同意加入中国饭店协会人力资源专业委员会，愿意承担相应责任，积极支持和配合专委会工作。
                    </div>
                    <div class="clearfix">
                        <div class="fl">
                            <div class="clearfix sign-item-1">
                                <span class="fl">负责人签名：</span>
                                <div class="fl">
                                    <el-input v-model="form.signName" size="mini"></el-input>
                                </div>
                            </div>
                            <div class="clearfix sign-item-2">
                                <div class="fl time-form-item">
                                    <el-input v-model="form.year" size="mini"></el-input>
                                </div>
                                <div class="fl sp-sign-label">年</div>
                                <div class="fl time-form-item">
                                    <el-input v-model="form.month" size="mini"></el-input>
                                </div>
                                <div class="fl sp-sign-label">月</div>
                                <div class="fl time-form-item">
                                    <el-input v-model="form.day" size="mini"></el-input>
                                </div>
                                <div class="fl sp-sign-label">日</div>
                            </div>
                        </div>
                    </div>
                </li>
                <!-- <li class="tb-form-li clearfix">
                    <div>
                        <span>请填写申请表发送至邮箱：</span>
                        <span>1063668170@qq.com</span>
                    </div>
                    <div>
                        <span> 联系人：</span>
                        <span style="margin-right:10px;">孙雷 18651902599</span>
                        <span>张翔 15210791982</span>
                    </div>
                </li> -->
                <li class="tb-form-li clearfix">
                    <p class="p-intro-title">备注：</p>
                    <p class="p-intro-title">1.会员服务费标准</p>
                    <div>
                          按照《中国饭店协会人力资源专业委员会工作规则》，会员服务费分为3类，
                        理事长单位服务费20000元/年，常务副理事单位服务费6000元/年，副理事单位服务费
                        3000元/年，委员单位服务费1000元/年。
                    </div>
                    <p class="p-intro-title">2.会员服务费缴纳账户</p>
                    <div>开户名称：中国饭店协会</div>
                    <div>开 户 行：中国银行北京月坛支行</div>
                    <div>银行账号：3363 5603 2944</div>
                    <div>行　　号：1041 0000 5864</div>
                </li>
            </ul>
            <div class="submit-apply-btn">
                <el-button type="primary" @click="submitTable('form',2)" size="small" :disabled="isSubmit">提交</el-button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import applyFileUpload from "components/uploads/uploadEnclosure.vue";
import phoneUploadAvatar from "components/uploads/avatarUpload.vue";
import avatarUpload from "components/avatarUpload.vue";
import {
    MU_UPATE_AUTH,
    MU_UPATE_SCHOOL
} from "store/index";
import Bus from "components/bus.js";
import newLogin from "components/newLogin.vue";
export default {
    data() {
        return {
            isdownloadloading: false,
            urlAliyunOSS: "/api/XOrg/osssign/getsign",
            headBg: require("assets/images/wlx-baic-bg-img.png"),
            form: {
                schoolName: '',
                representative: '',
                rePost: '',
                rePhoneNum: '',
                contactPerson: '',
                coPost: '',
                coPhoneNum: '',
                applyLevel: '',
                linkAddress: '',
                linkPost: '',
                linkWechat: '',
                schoolArea: '',
                schoolStuNum: '',
                isDoubleHeighSchool: '',
                isDobleHeighMajor: '',
                characteristicMajor: '',
                majorNum:'',
                briefIntro: '',
                signName: '',
                year: '',
                month: '',
                day: '',
                fileIds: []
            },
            timer: "",
            IsTipsDialog: false,
            showObject: {
                isShow: false
            },
            isSubmit: false,
            rules: {
                name: [{
                    required: true,
                    message: "请输入姓名",
                    trigger: "blur"
                }]
            },
            showTip: true,
            screenWidth: document.body.clientWidth,
            phoneTipVisible: false,
            tipLogWidth: "600px",
            isShowPc: true,
            imageUrl: "",
            fileList: [],
            files: [],
        };
    },
    props: {
        applyId: {
            type: String,
            default: ""
        }
    },
    computed: {
        userInfo() {
            return this.$store.state.auth;
        },
        association: function () {
            return this.$store.state.association;
        },
        target: function () {
            let Urlname = "";
            if (this.$store.state.auth.userType === 1) {
                Urlname = "stuBasicInfo";
            } else if (this.$store.state.auth.userType === 2) {
                Urlname = "EnrollManager";
            } else if (this.$store.state.auth.userType === 3) {
                Urlname = "siteBasicInfo";
            } else if (this.$store.state.auth.userType === 9) {
                Urlname = "MeetingManager";
            }
            return {
                name: Urlname
            };
        }
    },
    components: {
        avatarUpload,
        newLogin,
        phoneUploadAvatar,
        applyFileUpload
    },
    created() {
        if (this.screenWidth < 768) {
            this.tipLogWidth = "80%";
            this.isShowPc = false;
        } else {
            this.tipLogWidth = "600px";
            this.isShowPc = true;
        }
        this.getMemberApplyInfo();
    },
    methods: {
        printFile() {
            this.isPassForm().then(res => {
                if (res) {
                    this.$http
                        .post("/api/XOrg/MemberApply/saveApply", {
                            type: 0,
                            unitName: this.form.schoolName,
                            committeeLead: this.form.representative,
                            committeeLeadPost: this.form.rePost,
                            committeeLeadPhone: this.form.rePhoneNum,
                            contact: this.form.contactPerson,
                            contactPost: this.form.coPost,
                            contactPhone: this.form.coPhoneNum,
                            address: this.form.linkAddress,
                            email: this.form.linkPost,
                            weChat: this.form.linkWechat,
                            schoolArea: this.form.schoolArea,
                            schoolStuNum: this.form.schoolStuNum,
                            istWinSchool: this.form.isDoubleHeighSchool,
                            istWinMajor: this.form.isDobleHeighMajor,
                            tSMajor: this.form.characteristicMajor,
                            majorNum:this.form.majorNum,
                            socialCreditCode: '',
                            latelyIncome: '',
                            staffNum: '',
                            shopNum: '',
                            introduction: this.form.briefIntro,
                            headName: this.form.signName,
                            year: this.form.year,
                            month: this.form.month,
                            day: this.form.day,
                            userId: this.userInfo.userId,
                            fileIds: JSON.stringify(this.form.fileIds)
                        }).then(rst => {
                            if (rst.code > 0) {
                                this.downloadId = rst.id;
                                this.isdownloadloading = true;
                                this.saveTableFile(rst.id);
                            }
                        });
                }
            });
        },
        saveTableFile(id) {
            const url = `/api/XOrg/MemberApply/eportMemberApply?memberApplyId=${id}`;
            window.location = url;
            this.isdownloadloading = false;
        },
        onAllFilesUpload(files) {
            this.fileIds = [];
            this.form.fileIds = files;
        },
        getMemberApplyInfo() {
            this.$http
                .post("/api/XOrg/MemberApplyManager/getMemberApplyInfo", {
                    id: this.applyId
                })
                .then(res => {
                    if (res.code > 0) {
                        this.form.schoolName = res.info.unitName;
                        this.form.representative = res.info.committeeLead;
                        this.form.rePost = res.info.committeeLeadPost;
                        this.form.rePhoneNum = res.info.committeeLeadPhone;
                        this.form.contactPerson = res.info.contact;
                        this.form.coPost = res.info.contactPost;
                        this.form.coPhoneNum = res.info.contactPhone;
                        this.form.linkAddress = res.info.address;
                        this.form.linkPost = res.info.email;
                        this.form.linkWechat = res.info.weChat;
                        this.form.schoolArea = res.info.schoolArea;
                        this.form.schoolStuNum = res.info.schoolStuNum;
                        this.form.isDoubleHeighSchool = res.info.istWinSchool;
                        this.form.isDobleHeighMajor = res.info.istWinMajor;
                        this.form.characteristicMajor = res.info.tSMajor;
                        this.form.majorNum = res.info.majorNum;
                        this.form.briefIntro = res.info.introduction;
                        this.form.signName = res.info.headName;
                        this.form.year = res.info.year;
                        this.form.month = res.info.month;
                        this.form.day = res.info.day;
                        this.fileList = res.fileList;
                        res.fileList.forEach(ele => {
                            this.form.fileIds.push(ele.id);
                        });
                    }
                });
        },
        submitImg() {
            this.$refs.upload.submit();
        },
        backToPrev() {
            this.$router.go(-1);
        },
        fanhui() {
            this.$router.go(-1);
        },
        getAvatar() {
            console.log(this.form.avatar);
        },
        submitTable(formName, type) {
            var reg = /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/;
            if (this.form.schoolName == "") {
                this.$message({
                    message: "请输入院校名称",
                    type: "warning"
                });
                return false;
            }
            if (this.form.representative === "") {
                this.$message({
                    message: "请输入专委会代表人",
                    type: "warning"
                });
                return false;
            }
            if (this.form.rePost === "") {
                this.$message({
                    message: "请输入专委会代表人职务",
                    type: "warning"
                });
                return false;
            }
            if (this.form.rePhoneNum == "") {
                this.$message({
                    message: "请输入专委会代表人联系电话",
                    type: "warning"
                });
                return false;
            } else if (!reg.test(this.form.rePhoneNum)) {
                this.$message({
                    message: "专委会代表人手机号格式不正确",
                    type: "warning"
                });
                return false;
            }
            if (this.form.contactPerson == "") {
                this.$message({
                    message: "请输入联络人",
                    type: "warning"
                });
                return false;
            }

            if (this.form.coPost == "") {
                this.$message({
                    message: "请输入联络人职务",
                    type: "warning"
                });
                return false;
            }
            if (this.form.coPhoneNum == "") {
                this.$message({
                    message: "请输入联络人联系电话",
                    type: "warning"
                });
                return false;
            } else if (!reg.test(this.form.coPhoneNum)) {
                this.$message({
                    message: "联络人手机号格式不正确",
                    type: "warning"
                });
                return false;
            }

            if (this.form.linkAddress == "") {
                this.$message({
                    message: "请输入通讯地址",
                    type: "warning"
                });
                return false;
            }
            if (this.form.linkPost == "") {
                this.$message({
                    message: "请输入联系邮箱",
                    type: "warning"
                });
                return false;
            }

            if (this.form.linkWechat == "") {
                this.$message({
                    message: "请输入联系微信",
                    type: "warning"
                });
                return false;
            }
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.isSubmit = true;
                    this.$http
                        .post("/api/XOrg/MemberApplyManager/editMemberApply", {
                            type: 0,
                            unitName: this.form.schoolName,
                            committeeLead: this.form.representative,
                            committeeLeadPost: this.form.rePost,
                            committeeLeadPhone: this.form.rePhoneNum,
                            contact: this.form.contactPerson,
                            contactPost: this.form.coPost,
                            contactPhone: this.form.coPhoneNum,
                            address: this.form.linkAddress,
                            email: this.form.linkPost,
                            weChat: this.form.linkWechat,
                            schoolArea: this.form.schoolArea,
                            schoolStuNum: this.form.schoolStuNum,
                            istWinSchool: this.form.isDoubleHeighSchool,
                            istWinMajor: this.form.isDobleHeighMajor,
                            tSMajor: this.form.characteristicMajor,
                            majorNum:this.form.majorNum,
                            socialCreditCode: '',
                            latelyIncome: '',
                            staffNum: '',
                            shopNum: '',
                            introduction: this.form.briefIntro,
                            headName: this.form.signName,
                            year: this.form.year,
                            month: this.form.month,
                            day: this.form.day,
                            userId: this.userInfo.userId,
                            fileIds: JSON.stringify(this.form.fileIds),
                            id: this.applyId,
                        })
                        .then(res => {
                            if (res.code > 0) {
                                if (type == 1) {
                                    this.timer = setTimeout(this.goclpp, 5000);
                                    this.jumpLink(
                                        type,
                                        res.username,
                                        res.password,
                                        "即将跳转到管理系统..."
                                    );
                                } else {
                                    this.jumpLink(
                                        type,
                                        res.username,
                                        res.password,
                                        "即将返回..."
                                    );
                                }
                            } else {
                                this.isSubmit = false;
                                this.$message({
                                    message: res.msg,
                                    type: "warning"
                                });
                            }
                        });
                } else {
                    this.$message({
                        message: res.msg,
                        type: "warning"
                    });
                    return false;
                }
            });
        },
        isPassForm() {
            return new Promise((resolve, reject) => {
                var reg = /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/;
                if (this.form.schoolName == "") {
                    this.$message({
                        message: "请输入院校名称",
                        type: "warning"
                    });
                    return reject(false);
                }
                if (this.form.representative === "") {
                    this.$message({
                        message: "请输入专委会代表人",
                        type: "warning"
                    });
                    return reject(false);
                }
                if (this.form.rePost === "") {
                    this.$message({
                        message: "请输入专委会代表人职务",
                        type: "warning"
                    });
                    return reject(false);
                }
                if (this.form.rePhoneNum == "") {
                    this.$message({
                        message: "请输入专委会代表人联系电话",
                        type: "warning"
                    });
                    return reject(false);
                } else if (!reg.test(this.form.rePhoneNum)) {
                    this.$message({
                        message: "专委会代表人手机号格式不正确",
                        type: "warning"
                    });
                    return reject(false);
                }
                if (this.form.contactPerson == "") {
                    this.$message({
                        message: "请输入联络人",
                        type: "warning"
                    });
                    return reject(false);
                }

                if (this.form.coPost == "") {
                    this.$message({
                        message: "请输入联络人职务",
                        type: "warning"
                    });
                    return reject(false);
                }
                if (this.form.coPhoneNum == "") {
                    this.$message({
                        message: "请输入联络人联系电话",
                        type: "warning"
                    });
                    return reject(false);
                } else if (!reg.test(this.form.coPhoneNum)) {
                    this.$message({
                        message: "联络人手机号格式不正确",
                        type: "warning"
                    });
                    return reject(false);
                }

                if (this.form.linkAddress == "") {
                    this.$message({
                        message: "请输入通讯地址",
                        type: "warning"
                    });
                    return reject(false);
                }

                if (this.form.linkPost == "") {
                    this.$message({
                        message: "请输入邮箱",
                        type: "warning"
                    });
                    return reject(false);
                }
                if (this.form.linkWechat == "") {
                    this.$message({
                        message: "请输入联系微信",
                        type: "warning"
                    });
                    return reject(false);
                }
                return resolve(true);
            });
        },
        jumpLink(type, name, pass, info) {
            const h = this.$createElement;
            this.$message({
                message: h("div", null, [
                    h("p", null, [
                        h("span", {
                            style: "color: #000"
                        }, info)
                    ])
                ]),
                type: "success",
                duration: 5000
            });
            if (type == 1) {
                this.timer = setTimeout(this.goclpp, 5000);
            } else {
                this.timer = setTimeout(this.backToPrev, 5000);
            }
        },
        goclpp() {
            this.$router.push({
                name: "committeeApplyTea",
                params: {
                    certificateId: "mad6aiusg7rnlk4e6q6paw"
                }
            });
        },
        Gologin() {
            this.IsTipsDialog = false;
            this.showObject = {
                isShow: true
            };
        }
    },
    beforeDestroy() {
        clearInterval(this.timer);
        this.timer = null;
    }
};
</script>

<style lang="scss">
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}

.wlx-apply-table-wrapper {
    height: 100%;
    overflow: auto;
    background: #f0f6ff;

    .vip-apply-main-con {
        margin: 0 auto;
        width: 958px;
        border: 1px solid #999;
        border-top: none;
        border-bottom: none;

        .vip-apply-item {
            padding: 10px;
            font-size: 17px;
            border-bottom: 1px solid #999;

            .p-vip-title {
                margin: 3px 0;
                font-size: 17px;
                font-weight: bold;
            }

            .unit-idea-con {
                text-indent: 20px;
            }

            .company-intro-con {
                margin-top: 10px;

                .el-textarea__inner {
                    height: 120px;
                    border: 1px solid #DCDFE6;
                }
            }
        }

        .person-signName-con {
            margin-top: 40px;

            .sign-name-1 {
                .el-input {
                    border-bottom: 1px solid #999;
                }
            }

            .sign-name-2 {
                margin-top: 6px;

                .el-input {
                    width: 100px;
                    border-bottom: 1px solid #999;
                }
            }

            .sp-sign-label {
                margin-top: 3px;
            }

            .official-seal-con {
                margin: 21px 40px 0 0;
            }
        }
    }

    .basic-head-main {
        height: 706px;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center top;

        .basic-head-con {
            margin: 0 auto;
            width: 1000px;
        }

        .head-logo-con {
            padding: 26px 0 0 26px;
        }

        .logo-img-val {
            height: 40px;
        }

        .head-title-con {
            position: relative;
            padding-top: 40px;
        }

        .basic-book-img-con {
            margin-left: 10px;

            img {
                width: 290px;
            }
        }

        .head-title-word {
            position: absolute;
            right: 0;
            top: 130px;
            z-index: 100;
            color: #fff;
        }

        .p-title-1 {
            font-size: 55px;
            font-weight: bold;
            text-align: center;
        }

        .p-title-2-1 {
            margin-top: 50px;
            text-align: right;
            font-size: 20px;
        }
    }

    .apply-table-content {
        margin: -346px auto 0;
        padding: 20px 0;
        padding-top: 50px;
        width: 1000px;
        background: #fff;
    }

    .p-down-applyTable-btn {
        text-align: right;
        color: #0365f5;
        padding: 0 22px 20px 0;
        cursor: pointer;
        font-size: 17px;
    }

    .apply-table-title {
        padding: 20px 0;
        text-align: center;
    }

    .submit-apply-btn {
        padding: 20px 0;
        text-align: center;

        .el-button--primary {
            background: #05243D;
            border-color: #05243D;
        }
    }

    .label-job-con {
        padding: 0 20px;
    }

    table {
        margin: 0 auto;
        width: 960px;
        border-right: 1px solid #999;
        border-bottom: 1px solid #999;
        table-layout: fixed;
        word-break: break-all;
        background: #f0f0f0;
    }

    .u-label-title {
        font-weight: bold;
    }

    .demo-table {
        margin-top: 100px;
    }

    .expert-certify-ul {
        height: 100%;
    }

    .expert-certify-li {
        width: 25%;
    }

    .certify-li-cell {
        border-left: 1px solid #999;
        border-top: 1px solid #999;
    }

    .certify-li-cell-num {
        border-top: none;
    }

    .fistCertify {
        .certify-li-cell {
            border-left: none;
        }
    }

    .el-textarea__inner,
    .el-input__inner {
        border: none;
        font-size: 16px;
        color: #000;
    }

    .input-edu .el-input__inner {
        height: 82px;
        line-height: 82px;
    }

    .el-textarea__inner:focus {
        border: none;
    }

    .el-input__inner:focus {
        border: none;
    }

    .el-date-editor.el-input {
        width: 100%;
    }

    table td {
        border-left: 1px solid #999;
        border-top: 1px solid #999;
        text-align: center;
    }

    .label-opinion-title {
        padding: 10px;
        text-align: left;
    }

    .sp-mark-label {
        color: red;
    }

    .h4-major-title {
        padding: 10px 0;
    }

    td {
        height: 40px;
        // width: 76.9px;
        font-size: 16px;
    }

    .train-select-con {
        width: 100%;
    }

    .p-sign-up-tip {
        padding: 10px 0 0 20px;
    }

    .p-sign-up-tip-1 {
        margin-top: 40px;
    }

    .submit-btn {
        padding: 20px 0;
        text-align: center;
    }

    .wlx-is-fill-signUp-con {
        font-size: 16px;

        .p-name-pass-tip-con {
            margin-top: 10px;
            color: red;
        }
    }

    .train-sing-up-avatar-con {
        .el-upload-list--picture-card {
            .el-upload-list__item-thumbnail {
                width: auto;
            }
        }
    }
}
</style>
